import { Col, Space, Typography } from "antd";
const { Text } = Typography;

export const Labels = ({ skipRadio }) => {
  return (
    <Col span={3} style={{ minWidth: "160px" }}>
      <Space align="end" direction="vertical">
        <Col>
          <Text>Für Abfrage relevant:</Text>
        </Col>
        <Col>
          <Text>Unschärfe zulassen:</Text>
        </Col>
        {!skipRadio && (
          <Col>
            <Text>uID:</Text>
          </Col>
        )}
        <Col style={{ paddingTop: "5px" }}>
          <Text>Merkmal:</Text>
        </Col>
        <Col style={{ paddingTop: "5px" }}>
          <Text>Abfragephrase:</Text>
        </Col>
      </Space>
    </Col>
  );
};
